export default __webpack_public_path__ + "static/stylam-exclusive-c73e66837077cdbea5f0770adeb4e810.png";